<template>
    <div 
        v-tinymce="options"
        :key="renderKey"
        @mce-change="(list) => offerSectionSet({serviceList: list})"
        @mce-dirty="() => $emit('dirty')"
    >
        <div v-if="offerSections.serviceList" v-html="offerSections.serviceList"></div>
        <div v-else class="service-list">
            <ul v-if="offer.offerType_id === 4">
                <li>{{ $t('serviceList.openCancellation') }}</li>
                <li>{{ $t('serviceList.documents') }}</li>
                <li v-if="!isOnline">{{ $t('serviceList.refreshments') }}</li>
                <li v-else>{{ $t('serviceList.technicalSupport') }}</li>
            </ul>
            <ul v-else>
                <li>{{ $t('serviceList.adaptableContent') }}</li>
                <li>{{ $t('serviceList.flexibleDuration') }}</li>
                <li><span v-html="$t('serviceList.cancellationIntro')"></span><br>
                    <ul class="list-unstyled">
                        <li v-html="$t('serviceList.cancellation20')"></li>
                        <li v-html="$t('serviceList.cancellation14')"></li>
                        <li v-html="$t('serviceList.cancellation7')"></li>
                    </ul>
                </li>
                <li v-if="offer.offerType_id === 2">{{ $t('serviceList.shuttle') }}</li>
                <li v-if="offer.offerType_id === 2">{{ $t('serviceList.refreshments') }}</li>
                <li v-if="offer.offerType_id === 3">{{ $t('serviceList.refreshmentsAtGfu') }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'


export default {
    name: 'ServiceList',
    props: {
        options: Object,
    },
    data() {
        return {
            renderKey: 0
        }
    },
    computed: {
        ...mapGetters(['offerSections', 'offer']),
        isOnline() {
            return this.offer && this.offer.isRemote;
        }
    },
    methods: {
        ...mapMutations([
            'offerSectionSet'
        ])
    },
    watch: {
        options: function () {
            this.renderKey++;
        }
    }
}
</script>

<style scoped>
.list-unstyled>li::before {
    content: "none";
}
.list-unstyled>li {
    margin-top: 5px;
    list-style: initial;
    margin-left: 20px;
    padding-left: 0px;
}
.list-unstyled {
    margin-top: 10px;
}
</style>
